/** @format */

import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSanitizationPipe } from '@shared/utils/pipes';
import { MediaModule } from '@shared/media/components';

import { ITrending } from '@shared/data-access/interfaces';

@Component({
	selector: 'pdp-tech-icons',
	templateUrl: './tech-icons.component.html',
	styleUrl: './tech-icons.component.scss',
	imports: [CommonModule, BypassSanitizationPipe, MediaModule]
})
export class TechIconsComponent {
	@Input()
	public techIconsArray: ITrending[];

	protected trackByFn(index: number, item: ITrending): string {
		return index.toString() + item.headline;
	}
}
